export const joyrideStyles = {
  options: {
    arrowColor: "#1a1a1a",
    backgroundColor: "#1a1a1a",
    overlayColor: "rgba(0, 0, 0, 0.75)",
    primaryColor: "#FFC629",
    textColor: "#ffffff",
    spotlightShadow: "0 0 20px rgba(255, 198, 41, 0.3)",
    zIndex: 10000,
  },
  spotlight: {
    borderRadius: 12,
  },
};
